<template>
	<div class="container">
		<!--  顶部  -->
		<div class="header-box g-flex g-row-center" style="align-items: stretch">
			<div class="total-width g-rela">
				<!--  人才信息  -->
				<div class="g-flex g-m-l-40 g-col-top g-m-t-50">
					<img :src="detail.avatar?detail.avatar:$store.state.defaultAvatar" class="avatar" alt="">
					<div class="g-m-l-30">
						<div class="g-flex">
							<p class="white-text g-font-28 g-weight-font">{{detail.name}}</p>
							<p class="career-tag g-font-12">{{detail.workStatusName}}</p>
						</div>
						<div class="g-m-t-12 g-flex">
							<div class="star-bg g-font-10 white-text g-flex g-row-center">
								<p class="g-p-l-15">已获得：6颗星</p>
							</div>
							<div class="white-text g-font-14">
								<span class="g-m-l-10">{{detail.education}}</span>
								<span class="g-m-l-10 g-m-r-10">|</span>
								<span>{{detail.workYear}}年经验</span>
								<span class="g-m-l-10 g-m-r-10">|</span>
								<span>{{detail.salary}}</span>
							</div>
							<div class="g-m-l-30 g-font-14">
								<span class="white-text">已学习</span>
								<span class="yellow-text">138小时46分钟</span>
							</div>
						</div>
						<div class="g-m-t-30 g-flex">
							<div class="btn1" @click.stop="doInvite" v-if="detail.deliverStatus=='0'">邀请面试</div>
							<div class="btn2 g-m-l-30" @click.stop="doCollect" v-if="detail.collectId==-1||detail.collectId==''">收藏人才</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--  详情  -->
		<div class="g-flex g-row-center">
			<div class="total-width white-bg g-m-t-30">
				<div class="g-p-30">

					<!--  个人信息  -->
					<div class="total-title">个人信息</div>
					<div class="sub-box g-m-t-20 g-p-l-30 g-p-r-30">
						<div class="g-p-t-10 g-flex g-flex-wrap">
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>姓名：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.name}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>性别：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.gender==='1'?'男':'女'}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>生日：</p>
								<p class="g-m-l-10 g-weight-font">{{leftTenChar(detail.birth)}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>电话：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.phone}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>学历：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.education}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>期望薪资：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.salary}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>求职状态：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.workStatusName}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>邮箱：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.email}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>工作时长：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.workYear}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>求职岗位：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.postName}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>微信号：</p>
								<p class="g-m-l-10 g-weight-font">{{detail.wechat}}</p>
							</div>
						</div>
						<div class="g-m-t-20 g-flex g-col-top g-p-b-30">
							<p class="g-nowrap">个人简介：</p>
							<p class="g-weight-font">
								{{detail.profile}}
							</p>
						</div>
					</div>

					<!--  个人简历  -->
					<div v-if="detail.enclosure">
						<div class="total-title g-m-t-30">个人简历</div>
						<div class="g-flex g-m-t-20">
							<div class="career-pdf g-p-r-80">
								<div class="g-flex g-p-15">
									<a :href="detail.enclosure" target="_blank" style="display: flex;align-items: center;text-decoration:none">
										<img src="@/assets/find-careers/pdf-img.png" class="pdf-img" alt="">
										<p class="g-m-l-15 g-font-16">{{detail.name}}诊个人简历-{{detail.postName}}</p>
									</a>

								</div>
							</div>
						</div>
					</div>


					<!--  最近一次工作经历  -->
					<div class="total-title g-m-t-30" v-if="lastWork.status!=1">最近一次工作经历</div>
					<div class="sub-box g-m-t-20 g-p-l-30 g-p-r-30" v-if="lastWork.status!=1">
						<div class="g-p-t-10 g-flex g-flex-wrap">
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>公司名称：</p>
								<p class="g-m-l-10 g-weight-font">{{lastWork.name}}</p>
							</div>

							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>任职岗位：</p>
								<p class="g-m-l-10 g-weight-font">{{lastWork.postName}}</p>
							</div>
							<div class="info-item g-p-t-20 g-flex g-font-16">
								<p>薪资：</p>
								<p class="g-m-l-10 g-weight-font">{{lastWork.salary}}</p>
							</div>
						</div>
						<div class="info-item g-p-t-20 g-flex g-font-16">
							<p>所在城市：</p>
							<p class="g-m-l-10 g-weight-font">{{lastWork.cityName}}</p>
						</div>
						<div class="g-m-t-20 g-flex g-col-top g-p-b-30">
							<p class="g-nowrap">工作内容：</p>
							<p class="g-weight-font g-m-l-10">
								{{lastWork.workContent}}
							</p>
						</div>
					</div>

					<!--  资格证书  -->
					<div class="total-title g-m-t-30">资格证书</div>
					<div class="g-flex g-flex-wrap">
						<div class="g-m-t-20 papers" v-for="(item,index) in detail.certificateName.split(',')" :key="index" v-if="!!item">
							{{item}}
						</div>
					</div>
					<!--          &lt;!&ndash;  未登录  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">您还未登录，登录后可查看!</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去登陆</div>-->
					<!--            </div>-->
					<!--          </div>-->

					<!--          &lt;!&ndash;  不是招聘者  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">当前内容只对“招聘者”身份开放，请切换身份登录后查看</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去切换</div>-->
					<!--            </div>-->
					<!--          </div>-->

					<!--  其他证书  -->
					<div class="total-title g-m-t-30">其他证书</div>
					<div class="g-p-30 g-font-16">
						{{detail.certificateName}}
					</div>
					<!--          &lt;!&ndash;  未登录  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">您还未登录，登录后可查看!</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去登陆</div>-->
					<!--            </div>-->
					<!--          </div>-->

					<!--          &lt;!&ndash;  不是招聘者  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">当前内容只对“招聘者”身份开放，请切换身份登录后查看</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去切换</div>-->
					<!--            </div>-->
					<!--          </div>-->


					<!--  站内证书  -->
					<div class="total-title g-m-t-30">站内证书</div>
					<div class="g-flex g-flex-wrap">
						<el-image v-for="item in 4" :key="item" class="paper-img" src="./src/assets/examples/01.png"
							fit="fill"></el-image>
					</div>
					<!--          &lt;!&ndash;  未登录  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">您还未登录，登录后可查看!</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去登陆</div>-->
					<!--            </div>-->
					<!--          </div>-->

					<!--          &lt;!&ndash;  不是招聘者  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">当前内容只对“招聘者”身份开放，请切换身份登录后查看</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去切换</div>-->
					<!--            </div>-->
					<!--          </div>-->

					<!--  线上考核视频  -->
					<div class="total-title g-m-t-30">线上考核视频</div>
					<div class="g-flex g-flex-wrap">
						<div class="videos-box g-m-r-20 g-rela g-m-t-20" @mouseenter="doAnimate"
							@mouseleave="endAnimate">
							<div class="mask g-flex g-row-center" v-if="isHover">
								<img src="@/assets/find-careers/play-btn.png" class="play-btn" alt=""
									@click="dialogVisible = true">
							</div>
							<img src="@/assets/examples/02.png" class="video-poster" alt="">
						</div>
					</div>
					<!--          &lt;!&ndash;  未登录  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">您还未登录，登录后可查看!</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去登陆</div>-->
					<!--            </div>-->
					<!--          </div>-->

					<!--          &lt;!&ndash;  不是招聘者  &ndash;&gt;-->
					<!--          <div class="disabled-box g-m-t-20" >-->
					<!--            <div class="g-flex">-->
					<!--              <img src="@/assets/find-careers/warning-icon.png" class="error-icon" alt="">-->
					<!--              <p class="g-m-l-5 g-font-12">当前内容只对“招聘者”身份开放，请切换身份登录后查看</p>-->
					<!--              <div class="g-m-l-40 login-btn" @click="goLogin">去切换</div>-->
					<!--            </div>-->
					<!--          </div>-->
				</div>
			</div>
		</div>

		<!--  视频弹窗  -->
		<el-dialog title="" :visible.sync="dialogVisible" width="50%">

			<video width="100%" controls height="450px" class="videos">
				<source src="https://haokan.baidu.com/v?pd=wisenatural&vid=5221851231312681005">
			</video>
		</el-dialog>
		<!--  收藏提示  -->
		<message-popup ref="popup2" :showCancel="false" confirmText="知道了" @submit="doClose" @cancel="doClose">
		  <div class="g-text-center">
		    <p class="g-font-20 g-weight-font">收藏成功了！</p>
		    <p class="g-m-t-20 remark-text g-font-14">收藏成功，可在个人中心查看。</p>
		  </div>
		</message-popup>
		<!--  邀请面试弹窗  -->
		<invite-popup ref="popup"  @closeInvitePop="closeInvitePop" :id="id"></invite-popup>
	</div>
</template>

<script>
	import InvitePopup from "@/components/invite-popup";
	import messagePopup from "@/components/message-popup";
	import {
		getTalentDetail,
		lastworkDetailInfo,
		relationshipSubmit
	} from "@/api/job.js"
	import {
		dictionary
	} from "@/api/api.js"
	export default {
		name: "career-detail",
		components: {InvitePopup,messagePopup},
		data() {
			return {
				id:"",
				isHover: false,
				isAnimate: false,
				dialogVisible: false,
				detail:{},
				lastWork:{},
				resumeCertificate:[]
			}
		},
		computed: {
      getUserRole() {
        return this.$store.state.userInfo.role_name
      },
			isClinic(){
				return this.$store.state.isLogin&&(this.$store.state.userInfo.clinic_id!=''&&this.$store.state.userInfo.clinic_id!=-1)
			},
			isCustomer(){
				return this.$store.state.isLogin&&(this.$store.state.userInfo.clinic_id==''||this.$store.state.userInfo.clinic_id==-1)
			}
		},
		mounted(){
			this.id = this.$route.query.id
			this.getDetail()
			this.getLastWork()
			this.getResumeCertificate()
		},
		methods: {
			doCollect(){
			 // this.$refs.popup2.open();
			 relationshipSubmit({
			 	businessId:this.id,
			 	businessType:1
			 }).then(res=>{
			 	this.$refs.popup2.open()
			 })
			},
			doInvite() {
			  this.$refs.popup.open()
			},
			closeInvitePop(){
				 this.$refs.popup.close()
			},
			getLastWork(){
				lastworkDetailInfo({
					resumeId:this.id
				}).then(res=>{
					this.lastWork=res
				})
			},
			getDetail(){
				getTalentDetail({
					id:this.id
				}).then(res=>{
					this.detail=res
					if(this.detail.certificateName){
						if(this.detail.certificateName.startsWith(',')){
							this.detail.certificateName = this.detail.certificateName.substring(1)
						}
						if(this.detail.certificateName.endsWith(',')){
							this.detail.certificateName = this.detail.certificateName.substring(0,this.detail.certificateName.length-1)
						}
					}
				})
			},
			getResumeCertificate(){
				dictionary({code:'resume_certificate'}).then(res=>{
					console.log(res)
					this.resumeCertificate=res
				})
			},
			//鼠标移入的事件
			doAnimate() {
				setTimeout(() => {
					this.isHover = true
				}, 100)
			},
			//  鼠标移除事件
			endAnimate() {
				setTimeout(() => {
					this.isHover = false
				}, 100)
			},
			//  去登陆
			goLogin() {
				this.$router.push({
					name: 'login'
				})
			},
			leftTenChar(str){
				if(!str||str.length<10){
					return str;
				}
				return str.substring(0,10);
			},
			doClose(){

			}
		}
	}
</script>

<style lang="scss" scoped>
	.header-box {
		background-image: url("../../assets/find-job/store-top-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		width: 100%;
		height: 240px;

		.avatar {
			width: 118px;
			height: 118px;
			box-shadow: 0 0 10px 0 rgba(40, 48, 137, 0.50);
			border-radius: 50%;
		}

		.career-tag {
			background: #eea906;
			border-radius: 5px;
			padding: 3px 12px;
			color: #fff;
			margin-left: 15px;
		}

		.star-bg {
			background-image: url("../../assets/find-careers/stars-bg.png");
			background-size: 100% 100%;
			background-repeat: no-repeat;
			width: 106px;
			height: 28px;
		}
	}

	.btn {
		padding: 10px 50px;
		border-radius: 10px;
		cursor: pointer;
	}

	.btn1 {
		background: #fff;
		color: #407aff;
		@extend .btn;

		&:hover {
			background: rgba($color: #fff, $alpha: 0.5);
			color: #fff;
		}
	}

	.btn2 {
		background: rgba(255, 255, 255, 0.10);
		color: #fff;
		@extend .btn;

		&:hover {
			background: rgba($color: #fff, $alpha: 0.5);
			color: #fff;
		}
	}

	.white-bg {
		background: #fff;
		border-radius: 5px;
	}

	.total-title {
		font-size: 20px;
		font-weight: bold;
		color: #000;
		padding-bottom: 10px;
		border-bottom: 3px solid #407AFF;
		display: inline-block;
	}

	.sub-box {
		background: #f6f6f8;
		border-radius: 5px;

		.info-item {
			width: 25%;
		}
	}

	.career-pdf {
		background: #edf0fb;
		border-radius: 5px;

		.pdf-img {
			width: 34px;
			height: 34px;
		}
	}

	.papers {
		background: #edf0fb;
		border-radius: 5px;
		padding: 14px 28px;
		margin-right: 30px;
	}

	.paper-img {
		width: 214px;
		height: 162px;
		border-radius: 5px;
		margin: 20px 20px 0 0;
	}

	.video-poster {
		width: 270px;
		height: 180px;
		border-radius: 5px;
	}

	.mask {
		background: rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 0;
		left: 0;
		width: 270px;
		height: 180px;
		border-radius: 5px;
		cursor: pointer;
	}

	.play-btn {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}


	.videos {
		width: 100%;
		height: 400px;
	}

	.disabled-box {
		background: #edf0fb;
		border-radius: 5px;
		padding: 12px 20px;
		display: table;

		.error-icon {
			width: 26px;
			height: 26px;
		}

		.login-btn {
			background: #eea906;
			border-radius: 5px;
			color: #fff;
			padding: 4px 12px;
			font-size: 12px;
		}
	}
</style>
